// extracted by mini-css-extract-plugin
export default {"nameButton":"_40Qn9"};